const company_groupRouter = [
    {
        path: "list_company_group",
        name: "company_group",
        component: () => import("@/views/admin/company_group"),
        default: true,
        meta: {
            model: "company_group",
            // requiresAuth: true,
        },
    },
    {
        path: "list_company_group/add",
        name: "addCompanyGroup",
        component: () => import("@/views/admin/company_group/function"),
        default: true,
        meta: {
            model: "company_group",
            // requiresAuth: true,
        },
    },
    {
        path: "list_company_group/edit/:id",
        name: "editCompanyGroup",
        component: () => import("@/views/admin/company_group/function"),
        default: true,
        meta: {
            model: "company_group",
            // requiresAuth: true,
        },
    }
]
export default company_groupRouter;